import { Component } from "@angular/core";
import { Session } from "../../services/Session";

@Component({
  selector: "password-reset-banner",
  templateUrl: "./password-reset-banner.html",
})
export class PasswordResetBannerCmp {
  constructor(public session: Session) {}

  get show(): boolean {
    const u = this.session && this.session.user;
    return !!(u && u.id && u.migration_password_state === 1);
  }
}
